module.exports = [
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 1825
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 1732.37
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 1537.13
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 1391.13
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 1351.93
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 1298.6
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 1286.8
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 1083.8
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 977.27
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 969.6
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 905.57
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 914.27
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 958.03
  },
  {
    "AgeGroup": "55-64 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 931.95
  }
]
